import React from 'react';
import LegalDoc from '../components/LegalDoc';

/* Gizlilik Politikası. İçerik `translations[lang].privacy`. */
export default function PrivacyPage() {
  return <LegalDoc sozlukAnahtari="privacy" parlaklikRengi="rgba(139, 92, 246, 0.3)" />;
}
